import React, { useEffect, useState } from "react";
import {
  getAllDiagnosisRequest,
} from "../../api/DiagnosisApi";
import CoreLayout from "../../layouts/core-layout";
import { DashboardOfferBlock, NewDashboardOfferBlock } from "./components/AvailableOfferModal";
import HelpsModals from "../helps/helps-modals";
import { HelpsDashboard } from "../helps/contents/helps-dashboard";
import { useTranslation } from "react-i18next";
import { DiagnosisType } from "@/src/types/DiagnosisType";
import { useNavigate } from "react-router-dom";

const texts = [
  <HelpsDashboard />,
];
const Dashboard = () => {

  const { t } = useTranslation(); // Multi Language
  const navigate = useNavigate()
  const [diagnosisLoaded, setDiagnosisLoaded] = useState<boolean>(false)
  const [diagnosises, setDiagnosises] = useState<DiagnosisType[]>([]);

  useEffect(() => {
    getAllDiagnosisRequest()
      .then(function (res: any) {
        setDiagnosises(res.data.data);
        setDiagnosisLoaded(true)
      })
      .catch(() => {
        console.log("error");
      });
  }, []);

  useEffect(() => {
    if (!diagnosises?.length && diagnosisLoaded) {
      navigate('/diagnosis')
    }
  }, [diagnosises, diagnosisLoaded])

  return (
    <>

      <CoreLayout template="main">

        <div className="d-flex flex-column gap-4">

          <div className="d-flex justify-content-between align-items-center mt-8 mb-4">
            <h1 className="dashboard-offer-title fs-1">
              {t(
                "core:pages.account.account-quotation.AvailableOfferModal.diagAvailable"
              )}{" "}
            </h1>
            <HelpsModals texts={texts} initialIndex={0} />
          </div>

          <NewDashboardOfferBlock />

          {diagnosises?.map((e, index) => {
            return (
              <DashboardOfferBlock
                key={index}
                diagnosis={e}
                indexNumber={index + 1}
              />
            );
          })}

        </div>

      </CoreLayout >

    </>
  );
};

export default Dashboard;

export type AvailableType = {
  offerName: string;
  diagTotal: number;
  diagRest: number;
  pages: number;
  offerSlug: string;
};
